import React, { Component } from 'react';

const initialMessage = [{ "fulfillmentMessages": [{ "text": { "text": ["Hello, I'm an automated chatbot and not a live person. You can ask me short simple questions about unclaimed funds."] } }, { "text": { "text": ["Please do not enter personal information, such as your social security number or confirmation number. I'm not able to answer questions about the status of claims."] } }, { "payload": { "richContent": [[{ "type": "hint", "options": [{ "text": "Search tips", "topic": { "name": "How do I search for Unclaimed funds?", "id": "projects/dev-ouf-faq-dbmf/agent/intents/140297b5-e392-4d19-8f96-48c0010e0b0e" } }] }]] } }, { "payload": { "richContent": [[{ "options": [{ "text": "Required documentation", "topic": { "name": "Required Documents", "id": "projects/dev-ouf-faq-dbmf/agent/intents/b8c3d533-df44-488d-88a8-5ee4596c130e" } }], "type": "hint" }]] } }, { "payload": { "richContent": [[{ "type": "hint", "options": [{ "text": "What to expect from us", "topic": { "name": "What to expect from us", "id": "projects/dev-ouf-faq-dbmf/agent/intents/c7089dbb-99ca-484e-95fd-793bafaa9b5a" } }] }]] } }, { "payload": { "richContent": [[{ "type": "hint", "options": [{ "text": "How to upload documentation", "topic": { "id": "projects/dev-ouf-faq-dbmf/agent/intents/42bc85d9-ab0c-4864-afdf-673f959ff512", "name": "How do I upload documents..." } }] }]] } }] }];
const greeting = "Ask a Questuion"
const url = "https://ouf-notify.dirad.cloud"
const projectID = "prod-ouf-faq-qout"
const chatTitle = "Unclaimed Funds Bot"
const icon = "https://ouf-notify.dirad.cloud/chatbotIcon.png"


//How I have been building it on testbed
// npx babel --presets @babel/preset-react src/ChatbotWidget.js --out-file App.js
// move app.js to chatbot app 
// npm run chatbot



export default class ChatbotWidget extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			sessionID: this.generateUniqueID(),
			activated: false,
			userInput: '',
			messages: initialMessage,
			mobile: window.matchMedia('(max-device-width: 667px)').matches
		}
	}


	activateChat = () => {
		this.setState({ activated: true }, () => {
			this.userInputBox.focus()
		})
	}

	cancelChat = () => {
		this.setState({ activated: false })
		fetch(((url) ? url : window.location.origin) + '/dialogflow/html/endchat', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				"sessionId": this.state.sessionID
			})
		})
	}
	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.submit();
		}
	}
	clickHint = (topic, text, e) => {
		this.state.userInput = text
		var newMessageList = JSON.parse(JSON.stringify(this.state.messages))
		newMessageList.push(this.state.userInput)
		this.setState({ messages: newMessageList, userInput: '' }, () => {
			fetch(url + '/dialogflow/html/message/?project=' + projectID, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					"sessionId": this.state.sessionID,
					"text": "Hint||" + text + "||" + topic.id
				})
			}).then(
				(response) => {
					return response.json()
				}
			).then((data) => {
				var newMessageList = JSON.parse(JSON.stringify(this.state.messages))
				newMessageList.push(data)
				this.setState({ messages: newMessageList, userInput: '' })
			});
		})
	}
	generateUniqueID = () => {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}
	type = (e) => {
		this.setState({ userInput: e.currentTarget.value })
	}
	scrollToBottom = () => {
		if (this.messagesEnd) {
			this.messagesEnd.scrollIntoView({ behavior: "smooth" });
		}

	}
	backgroundDarken = (e) => {
		e.target.style.background = 'rgba(0, 0, 0, 0.5)';
	}
	backgroundLighten = (e) => {

		e.target.style.background = 'rgb(221, 221, 221)';
	}
	componentDidUpdate() {
		this.scrollToBottom();
	}
	componentDidMount() {
		window.addEventListener('beforeunload', this.cancelChat)
	}
	componentWillUnmount() {
		this.cancelChat()
	}
	submit = (e) => {
		var submissionText = this.state.userInput
		var newMessageList = JSON.parse(JSON.stringify(this.state.messages))
		newMessageList.push(this.state.userInput)
		this.setState({ messages: newMessageList, userInput: '' }, () => {
			fetch(url + '/dialogflow/html/message/?project=' + projectID, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					"sessionId": this.state.sessionID,
					"text": submissionText
				})
			}).then(
				(response) => {
					return response.json()
				}
			).then((data) => {
				var newMessageList = JSON.parse(JSON.stringify(this.state.messages))
				newMessageList.push(data)
				this.setState({ messages: newMessageList, userInput: '' })
			});
		})



	}
	render() {
		if (!this.state.activated) {
			return (
				<div style={{ position: 'fixed', bottom: '40px', right: '40px', display: 'flex' }} onClick={this.activateChat}>
					<div key={'chatbox'} style={{ backgroundColor: '#e5e5e5', borderRadius: '4px', bottom: '105px', boxShadow: 'rgba(0, 0, 0, 0.5) 1px 4px 15px 0px', display: 'flex', flexDirection: 'column', position: 'fixed', right: '20px', transform: 'translateX(25%) translateY(35%) scale(.5, .5)', opacity: 0, transition: 'transform 0.2s ease, opacity 0.2s ease-in, height 0s ease 0.2s', width: '370px', overflow: 'hidden' }}>
					</div>
					<div style={{ display: 'flex', padding: '10px', marginRight: '20px', borderRadius: '4px', bottom: '105px', boxShadow: 'rgba(0, 0, 0, 0.5) 1px 4px 15px 0px', backgroundColor: '#fff' }}>
						<div style={{ background: 'white', border: '1px solid #e0e0e0', borderRadius: '20px', color: 'rgba(0,0,0,0.87)', fontFamily: 'Roboto, sans-serif', fontSize: '14px', padding: '10px 16px', wordBreak: 'break-word' }} className="testing"> {greeting}
						</div>
						<div >
							<svg style={{ position: 'relative', top: '7px', marginLeft: '5px' }} height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
								<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
								<path d="M0 0h24v24H0z" fill="none"></path>
							</svg>
						</div>
					</div>
					<div style={{ background: '#fff', border: 'none', borderRadius: '50%', bottom: '0px', boxShadow: 'rgba(0, 0, 0, 0.5) 1px 4px 15px 0px', cursor: 'pointer', height: '56px', right: '0px', width: '56px' }}>
						<img style={{ height: '36px', width: '36px', position: 'relative', top: '10px', left: '10px' }} src={icon} />
					</div>
				</div>
			)
		}

		var messages = []
		for (var [i, message] of this.state.messages.entries()) {
			if (message instanceof Object) {
				for (var segment of message.fulfillmentMessages) {
					if (!segment.hasOwnProperty('platform')) {
						if (segment.hasOwnProperty('text')) {
							messages.push(
								<div style={{ background: 'rgb(221, 221, 221)', border: '1px solid #e0e0e0', borderRadius: '20px', color: 'rgba(0,0,0,0.87)', flex: '0 0 auto', fontFamily: 'Roboto, sans-serif', fontSize: '14px', marginTop: '10px', maxWidth: 'calc(100% - 28px)', padding: '7px 16px', wordBreak: 'break-word', wordWrap: 'break-word', alignSelf: 'flex-start', backgroundColor: '#fff', marginRight: '75px' }}>{segment.text.text[0]}</div>
							)

						} else if (segment.hasOwnProperty('payload')) {
							if (segment.payload.richContent[0][0].type == 'chips') {
								messages.push(
									<a target="_blank" style={{ textAlign: 'center' }} href={segment.payload.richContent[0][0].options[0].link}>
										<div style={{ display: 'inline-block', background: 'rgb(221, 221, 221)', border: '1px solid #e0e0e0', borderRadius: '20px', color: 'rgba(0,0,0,0.87)', flex: '0 0 auto', fontFamily: 'Roboto, sans-serif', fontSize: '14px', marginTop: '10px', maxWidth: 'calc(100% - 28px)', padding: '7px 16px', wordBreak: 'break-word', wordWrap: 'break-word', alignSelf: 'flex-start', backgroundColor: '#fff', marginRight: '75px' }}>

											<span>{segment.payload.richContent[0][0].options[0].text}</span>
											<svg xmlns='http://www.w3.org/2000/svg' fill='black' height='15' viewBox='0 0 24 24' width='15'>
												<path d='M0 0h24v24H0z' fill='none' /> <path d='M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' />
											</svg>
										</div>


									</a>
								)
							} else if (segment.payload.richContent[0][0].type == 'image') {
								messages.push(
									<img src={segment.payload.richContent[0][0].rawUrl} style={{ width: '100%' }} />

								)
							}
							else if (segment.payload.richContent[0][0].type == 'hint') {
								let topic = segment.payload.richContent[0][0].options[0].topic
								let text = segment.payload.richContent[0][0].options[0].text
								messages.push(
									<a target="_blank" style={{ textAlign: 'left' }} onClick={(e) => { this.clickHint(topic, text, e) }}>
										<div style={{ display: 'inline-block', background: 'rgb(224, 224, 224)', border: '1px solid #e0e0e0', borderRadius: '20px', color: 'rgba(0,0,0,0.87)', flex: '0 0 auto', fontFamily: 'Roboto, sans-serif', fontSize: '14px', marginTop: '10px', maxWidth: 'calc(100% - 28px)', padding: '7px 16px', wordBreak: 'break-word', wordWrap: 'break-word', alignSelf: 'flex-start', backgroundColor: 'rgb(224, 224, 224)', marginRight: '75px' }} onMouseOver={this.backgroundDarken} onMouseOut={this.backgroundLighten}>
											{segment.payload.richContent[0][0].options[0].text}
										</div>


									</a>
								)
							}


						}
					}
				}
				messages.push(
					<div style={{ color: 'rgba(0,0,0,0.7)', flex: '0 0 auto', fontFamily: 'Roboto, sans-serif', fontSize: '12px', marginTop: '5px', maxWidth: 'calc(100% - 28px)', wordBreak: 'break-word', wordWrap: 'break-word', alignSelf: 'flex-start', marginRight: '75px' }}>{new Date(message.timestamp).toLocaleString()}</div>)
			} else {
				messages.push(
					<div style={{ background: 'rgb(221, 221, 221)', border: '1px solid #e0e0e0', borderRadius: '20px', color: 'rgba(0,0,0,0.87)', flex: '0 0 auto', fontFamily: 'Roboto, sans-serif', fontSize: '14px', marginTop: '10px', maxWidth: 'calc(100% - 28px)', padding: '7px 16px', wordBreak: 'break-word', wordWrap: 'break-word', alignSelf: 'flex-end', backgroundColor: '#ddd', marginLeft: '75px' }}>{message}</div>

				)
				messages.push(
					<div style={{ color: 'rgba(0,0,0,0.7)', flex: '0 0 auto', fontFamily: 'Roboto, sans-serif', fontSize: '12px', marginTop: '5px', maxWidth: 'calc(100% - 28px)', wordBreak: 'break-word', wordWrap: 'break-word', alignSelf: 'flex-end', marginLeft: '75px' }}>{this.state.messages[i + 1] ? new Date(this.state.messages[i + 1].messageReceivedTimestamp).toLocaleString() : new Date().toLocaleString()}</div>)
			}
			messages.push(
				<div ref={(el) => { this.messagesEnd = el; }}></div>
			)
		}
		return (
			<div style={{ position: 'fixed', bottom: '40px', right: '40px', display: 'flex' }} onKeyUp={this.checkEnter}>
				<div key={'chatbox'} style={{ backgroundColor: '#e5e5e5', height: '560px', borderRadius: '4px', bottom: '105px', boxShadow: 'rgba(0, 0, 0, 0.5) 1px 4px 15px 0px', display: 'flex', flexDirection: 'column', position: 'fixed', right: '40px', transform: 'translateX(0%) translateY(0%) scale(1, 1)', opacity: 1, transition: 'transform 0.2s ease, opacity 0.2s ease-in, height 0s ease 0.2s', width: '370px', overflow: 'hidden' }}>
					<div style={{ alignItems: 'center', zIndex: 2, backgroundColor: '#ffffff', borderRadius: '5px 5px 0 0', boxShadow: '0px 3px 6px 0px #00000080', color: '#009ada', display: 'flex', fontFamily: 'Roboto, sans-serif', fontSize: '18px', height: '50px', justifyContent: 'space-between', paddingLeft: '15px' }}>{chatTitle}</div>
					<div style={{ display: 'flex', backgroundColor: '#fff', flexDirection: 'column', flex: '1 1', overflowX: 'hidden', overflowY: 'scroll', padding: '10px' }}>{messages}</div>
					<div style={{ borderTop: '1px solid #eeeeee', backgroundColor: '#fff', display: 'flex', fontFamily: 'Roboto, sans-serif', height: '50px' }}>
						<input ref={(el) => { this.userInputBox = el; }} style={{ backgroundColor: 'white', border: 'none', borderRadius: '0 0 4px 4px', color: 'rgba(0,0,0,0.87)', fontSize: '14px', paddingLeft: '15px', width: '100%' }} value={this.state.userInput} placeholder={this.props.placeholder} onChange={this.type}></input>
						<svg style={{ cursor: 'pointer', fill: '#42A5F5', flex: '0 0 auto', height: '24px', margin: '15px', viewbox: '0 0 24 24', width: '24px' }} onClick={this.submit} xmlns="http://www.w3.org/2000/svg" id="sendIcon">
							<path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path>
							<path d="M0 0h24v24H0z" fill="none"></path>
						</svg>
					</div>

				</div>
				<div onClick={this.cancelChat} style={{ background: '#fff', border: 'none', borderRadius: '50%', bottom: '0px', boxShadow: 'rgba(0, 0, 0, 0.5) 1px 4px 15px 0px', cursor: 'pointer', height: '56px', right: '0px', width: '56px' }}>
					<svg style={{ fill: '#42A5F5', left: '15px', position: 'absolute', top: '15px' }} id="closeSvg" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
						<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
						<path d="M0 0h24v24H0z" fill="none"></path>
					</svg>
				</div>
			</div>
		)
	}
}